import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659df461"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mask" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref, watch } from 'vue';
  import { getCaptchaSrc } from '@/utils';

  export interface IProps {
    modelValue?: boolean;
  }

  export interface IEmits {
    (event: 'update:modelValue', modelValue: boolean): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean }

  

  // 组件 slot 里面 可能会存在获取不到实例的情况，所以支持通过 v-model 来手动刷新
  watch(() => props.modelValue, val => {
    if (val) {
      handleRefresh();
    }
  });

  
  const captchaImgSrc = ref(getCaptchaSrc());
  const loading = ref(true);

  function handleRefresh() {
    if (!loading.value) {
      loading.value = true;
      captchaImgSrc.value = getCaptchaSrc();
      emits('update:modelValue', false);
    }
  }

  expose({ handleRefresh });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "captcha-wrapper",
    onClick: handleRefresh
  }, [
    _createElementVNode("img", {
      class: "captcha",
      src: captchaImgSrc.value,
      style: _normalizeStyle({opacity: loading.value ? 0.4 : 1}),
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (loading.value = false)),
      onError: _cache[1] || (_cache[1] = ($event: any) => (loading.value = false))
    }, null, 44, _hoisted_1),
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
      [_vShow, loading.value]
    ])
  ]))
}
}

})